var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.76 501.76",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faebb6"
    },
    d: "M344.6,281.44v136.533c0,34.133-17.067,51.2-51.2,51.2c-10.24,0-17.067-7.68-17.067-17.067 c0-68.267,0-110.933-34.133-145.067c-25.6-25.6-51.2-42.667-68.267-42.667H139.8v-204.8h34.133 c59.733-8.533,51.2-34.133,119.467-34.133h128c12.8,0,25.6,11.947,25.6,25.6s-11.947,25.6-25.6,25.6H447 c18.773,0,34.133,15.36,34.133,34.133s-15.36,34.133-34.133,34.133h17.067c18.773,0,34.133,15.36,34.133,34.133 s-15.36,34.133-34.133,34.133c19.627,2.56,34.133,10.24,34.133,29.013s-15.36,39.253-34.133,39.253H344.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAB1BA"
    },
    points: "139.8,264.373 139.8,281.44 3.267,281.44 3.267,25.44 139.8,25.44 139.8,59.573 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE079"
    },
    cx: 71.533,
    cy: 221.707,
    r: 8.533
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51565F"
    },
    d: "M294.4,477.44c-11.947,0-21.333-9.387-21.333-21.333c0-68.267,0-109.227-33.28-141.653 c-25.6-25.6-50.347-41.813-64.853-41.813c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267 c17.067,0,43.52,16.213,71.68,43.52C281.6,342.613,281.6,387.84,281.6,456.107c0,7.68,5.12,12.8,12.8,12.8 c31.573,0,46.933-15.36,46.933-46.933v-102.4c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v102.4 C349.867,458.667,331.093,477.44,294.4,477.44z M311.467,323.84c-2.56,0-4.267-1.707-4.267-4.267c0-30.72,24.747-38.4,38.4-38.4 h119.467c17.067,0,29.867-18.773,29.867-34.987c0-14.507-10.24-23.04-30.72-24.747c-2.56,0-4.267-2.56-3.413-4.267 s1.707-4.267,4.267-4.267c16.213,0,29.867-13.653,29.867-29.867s-13.653-29.867-29.867-29.867H448c-2.56,0-4.267-1.707-4.267-4.267 s1.707-4.267,4.267-4.267c16.213,0,29.867-13.653,29.867-29.867S464.213,84.907,448,84.907h-25.6c-2.56,0-4.267-1.707-4.267-4.267 c0-2.56,1.707-4.267,4.267-4.267c11.093,0,21.333-10.24,21.333-21.333s-10.24-21.333-21.333-21.333h-128 c-36.693,0-50.347,7.68-65.707,15.36c-11.947,6.827-26.453,14.507-53.76,17.92c-2.56,0-4.267-1.707-5.12-3.413 c-0.853-1.707,1.707-4.267,3.413-5.12c25.6-3.413,38.4-10.24,50.347-17.067c15.36-8.533,30.72-17.067,69.12-17.067h128 c15.36,0,29.867,14.507,29.867,29.867c0,8.533-3.413,16.213-9.387,21.333h5.12c21.333,0,38.4,17.067,38.4,38.4 c0,11.947-5.973,23.04-15.36,30.72c17.92,3.413,32.427,18.773,32.427,37.547c0,14.507-8.533,27.307-20.48,34.133 c13.653,5.12,20.48,15.36,20.48,29.867c0,20.48-16.213,43.52-38.4,43.52H343.893c-0.853,0-29.867,0.853-29.867,29.867 C315.733,322.133,314.027,323.84,311.467,323.84z M140.8,289.707H4.267C1.707,289.707,0,288,0,285.44v-256 c0-2.56,1.707-4.267,4.267-4.267H140.8c2.56,0,4.267,1.707,4.267,4.267v256C145.067,288,143.36,289.707,140.8,289.707z M8.533,281.173h128V33.707h-128V281.173z M72.533,238.507c-6.827,0-12.8-5.973-12.8-12.8c0-6.827,5.973-12.8,12.8-12.8 c6.827,0,12.8,5.973,12.8,12.8C85.333,232.533,79.36,238.507,72.533,238.507z M72.533,221.44c-2.56,0-4.267,1.707-4.267,4.267 c0,2.56,1.707,4.267,4.267,4.267c2.56,0,4.267-1.707,4.267-4.267C76.8,223.147,75.093,221.44,72.533,221.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownBlack);
export default __webpack_public_path__ + "static/media/thumb-down-black.63ab247eac77ff5926ff12de325f9de7.svg";
export { ForwardRef as ReactComponent };